// extracted by mini-css-extract-plugin
export default {"container":"Dogs_container__FblXA","imagen":"Dogs_imagen__apP4k"};